<div class="pf">

  <!-- ============================================================== head -->
  <div class="st-head">
    <div class="st-head-copy">
      <div class="st-eyebrow">Account</div>
      <h1 class="st-h1">Profile</h1>
      <p class="st-lead">How you are identified inside the app and on every report you generate.</p>
    </div>
    <button type="button" class="st-btn st-btn--ghost change-password" (click)="changePassword()"
      title="Change Password">
      <mat-icon>lock_reset</mat-icon>Change password
    </button>
  </div>

  <div class="st-grid">
    <div class="st-col">

      <!-- ========================================================== photo -->
      <section class="st-panel">
        <div class="st-panel-head">
          <mat-icon>account_circle</mat-icon>
          <h2 class="st-h2">Profile photo</h2>
        </div>

        <div class="pf-identity">
          <label for="UploadControl" title="Click to change profile image" class="pf-avatar">
            <img class='imgProfile' [src]="appComponent.user.profileImage ?
                appComponent.user.profileImage :
                'data:image/png;base64,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'
                | safe: 'resourceUrl'">
          </label>
          <div class="pf-identity-copy">
            <input type='file' (change)="onSelectFile($event)" id="UploadControl" style="display:none;"
              accept="image/png, image/gif, image/jpeg" />
            <label for="UploadControl" id="lblUploadText" class="UploadPhoto st-btn st-btn--ghost"
              title="Click to change profile image">Upload your photo</label>
            <p class="uploadHelp">Recommended size 200&nbsp;&times;&nbsp;200px. Shown only inside the application, for
              identification.</p>
          </div>
        </div>
      </section>

      <!-- ========================================================= details -->
      <section class="st-panel">
        <div class="st-panel-head">
          <mat-icon>badge</mat-icon>
          <h2 class="st-h2">Account details</h2>
        </div>

        <div class="st-field">
          <label class="st-label" for="usersEmailAddress">Email <span class="st-label-note">Locked</span></label>
          <input #usersEmailAddress id="usersEmailAddress" class="st-input" disabled='true'
            [(ngModel)]="appComponent.user.usersEmail" />
          <p class="st-hint">Your login credential — changed only by contacting support.</p>
        </div>

        <div class="st-field">
          <label class="st-label" for="legalName">Legal name</label>
          <input #legalName id="legalName" class="st-input" placeholder="Enter legal name..." minlength="1"
            maxlength="30" [(ngModel)]="appComponent.user.legalName" />
          <p class="st-err" *ngIf="legalName.invalid">required</p>
          <p class="st-hint">Used on all officially generated reports and documents.</p>
        </div>

        <div class="st-field">
          <label class="st-label" for="displayName">Display name</label>
          <input #displayName id="displayName" class="st-input" placeholder="Enter display name..." minlength="1"
            maxlength="30" [(ngModel)]="appComponent.user.displayName" />
          <p class="st-err" *ngIf="displayName.invalid">required</p>
          <p class="st-hint">Visible to your team members and used for in-app interactions.</p>
        </div>

        <!-- The permanent home of the time zone warning. NOT dismissible and no
             action button: this is the control that fixes it, so the message has
             to survive a dismissal made on the Console or My Notebooks, and a
             button that reopens this page would be noise. -->
        <app-timezone-warning [dismissible]="false" [showAction]="false"></app-timezone-warning>

        <div class="st-field">
          <label class="st-label" for="time">Time zone</label>
          <select #timeZone id="time" class="st-input" [ngModel]="displayedTimeZone" (ngModelChange)="onTimeZoneSelected($event)">
            <option *ngFor="let timeZone of alltimeZones" [value]="timeZone.timeZoneId">
              {{timeZone.display}}
            </option>
          </select>
          <p class="st-hint">Sets how dates and times are displayed in the app and in generated reports.</p>
        </div>

        <div class="st-field">
          <label class="st-label">Preferred language for AI tools</label>
          <select #preferredLanguage id="time" class="st-input"
            [(ngModel)]="appComponent.user.preferredLanguageISO639">
            <option></option>
            <option *ngFor="let language of openAIService.supportedLanguages" [value]="language.code">
              {{language.name}}
            </option>
          </select>
          <p class="st-hint">AI Tools reply in this language when the same language is used as input. English input
            always returns English.</p>
        </div>
      </section>

      <!-- ========================================================= actions -->
      <div class="st-actions">
        <div id="successfull" class="pf-saved">{{successmsg}}</div>
        <button type="button" class="st-btn st-btn--primary" (click)="updateProfile()">
          <img src="assets/images/progress-spinner.gif" class="button-spinner" *ngIf="loading" />
          Save profile changes
        </button>
      </div>
    </div>

    <!-- ============================================================ aside -->
    <aside class="st-aside">
      <div class="st-panel-head">
        <mat-icon>info</mat-icon>
        <h2 class="st-h2">Good to know</h2>
      </div>

      <div class="st-note">
        <mat-icon>gavel</mat-icon>
        <span>Your <b>legal name</b> is what appears on generated notebooks and reports — the name a court or client
          sees. Your <b>display name</b> never leaves the app.</span>
      </div>

      <div class="st-note">
        <mat-icon>schedule</mat-icon>
        <span>Notes are timestamped in UTC and rendered in your <b>time zone</b>. Changing it re-renders existing
          timestamps; it does not alter the recorded time.</span>
      </div>

      <div class="st-note">
        <mat-icon>lock</mat-icon>
        <span>Your <b>email</b> is your login credential and is locked here. Contact support to change it.</span>
      </div>

      <div class="st-note">
        <mat-icon>translate</mat-icon>
        <span>The <b>AI language</b> preference only affects AI Tool responses. English input defaults to English
          regardless of this setting.</span>
      </div>
    </aside>
  </div>
</div>

<!-- Change Password Dialog -->
<ejs-dialog id='ejDialogChangePassword' #ejDialogChangePassword showCloseIcon='true' header='Change Password'
  cssClass="fn-dialog fn-settings-form" [target]='targetElement' width='600px' [visible]="false" isModal="true">

  <div class="pf-pw">
    <div class="st-note">
      <mat-icon>shield</mat-icon>
      <span>Minimum requirements: <b>8 characters</b>, one uppercase, one lowercase and one digit.</span>
    </div>

    <form [formGroup]="form" (ngSubmit)="onSubmit(form)" novalidate>
      <div class="project-modal-content">

        <div class="st-field">
          <label class="st-label" for="password">New password</label>
          <input #password id="password" class="st-input" placeholder="Enter new password..." formControlName="password"
            type="password" minlength="1" maxlength="30" autocomplete="new-password" />
          <p class="st-err"
            *ngIf="form.controls['password'].invalid && (form.controls['password'].dirty || form.controls['password'].touched)">
            Password does not meet minimum requirements — 8 chars, 1 upper, 1 lower, 1 digit</p>
        </div>

        <div class="st-field">
          <label class="st-label" for="c_password">Confirm password</label>
          <input #c_password id="c_password" class="st-input" placeholder="Confirm new password..."
            formControlName="c_password" type="password" minlength="1" maxlength="30" autocomplete="new-password" />
          <p class="st-err"
            *ngIf="form.controls['c_password'].invalid && (form.controls['c_password'].dirty || form.controls['c_password'].touched)">
            Password does not meet minimum requirements — 8 chars, 1 upper, 1 lower, 1 digit</p>
          <p class="st-err" *ngIf="form.controls['c_password'].value != form.controls['password'].value">Passwords do not
            match</p>
        </div>

      </div>
      <div class="st-actions st-actions--split">
        <button type="button" class="st-btn st-btn--ghost" (click)="hideDialog()">
          Cancel
        </button>
        <button type="submit" class="st-btn st-btn--primary">
          <img src="assets/images/project.gif" class="button-spinner" *ngIf="loading" />
          Update password
        </button>
      </div>
    </form>
  </div>

</ejs-dialog>
